import { Timeplan } from './timeplan';

export const MOCKTIMEPLANS: Timeplan[] = [
  {
    period: 'September',
    category: 'incremental',
    objective: ['To conquer the world']
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/strategy-overview/timeplans/mock-timeplans.ts